<template>
	<div>
		<div style="display: flex; flex-wrap: wrap; width: 100%">
			<div
				v-if="guidanceData.length == 0"
				style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%">
				<el-empty description="暂无指引任务"></el-empty>
			</div>
			<div
				v-for="(item, index) in guidanceData"
				style="width: 250px; margin: 20px; position: relative; cursor: pointer"
				@click="goComplte(item, index)">
				<el-tag v-if="item.completed" class="guidance-status" size="small" type="success">已完成</el-tag>
				<el-tag v-if="!item.completed" class="guidance-status" size="small" type="danger">未完成</el-tag>
				<el-card :key="index" class="box-card">
					<div class="guidance-main">
						<svg
							v-if="item.type == 'pdf'"
							class="icon"
							height="100"
							p-id="5448"
							t="1671761349703"
							version="1.1"
							viewBox="0 0 1024 1024"
							width="100"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.217 637.256c-15.174-0.489-31.314 0.67-49.65 2.964-24.298-14.987-40.654-35.582-52.274-65.827 0.28-1.152 0.86-3.538 1.063-4.38 0.474-1.958 0.867-3.594 1.243-5.185 4.293-18.13 6.615-31.358 7.3-44.695 0.518-10.074-0.04-19.368-1.827-27.976-3.298-18.584-16.454-29.453-33.021-30.126-15.446-0.627-29.649 7.993-33.281 21.373-5.913 21.612-2.45 50.07 10.08 98.582-15.964 38.056-37.052 82.661-51.203 107.539-18.885 9.74-33.604 18.605-45.953 28.427-16.303 12.966-26.48 26.29-29.286 40.306-1.355 6.48 0.692 14.966 5.36 21.912 5.296 7.879 13.282 12.991 22.855 13.735 24.152 1.877 53.83-23.024 86.59-79.258 3.295-1.09 6.78-2.257 11.026-3.69 2.323-0.783 10.464-3.538 11.91-4.026 7.521-2.54 12.98-4.36 18.376-6.116 23.396-7.612 41.096-12.429 57.21-15.163 27.973 14.973 60.316 24.796 82.098 24.796 17.979 0 30.126-9.319 34.515-23.985 3.857-12.886 0.794-27.824-7.473-36.084-8.56-8.41-24.3-12.434-45.658-13.123z m-247.985 128.42v-0.36l0.126-0.338c1.275-3.421 3.157-7.008 5.6-10.758 4.284-6.576 10.173-13.5 17.472-20.865 3.92-3.955 8.002-7.8 12.79-12.12 1.073-0.969 7.91-7.059 9.189-8.25l11.176-10.407-8.12 12.934c-12.326 19.638-23.46 33.78-33.013 43.004-3.507 3.387-6.6 5.9-9.091 7.505-1.027 0.662-1.916 1.144-2.613 1.424-0.409 0.163-0.771 0.268-1.13 0.302a2.202 2.202 0 0 1-1.117-0.16 2.068 2.068 0 0 1-1.269-1.911z m125.934-218.269l-2.26 4.007-1.39-4.385c-3.114-9.829-5.387-24.641-6.016-37.997-0.716-15.197 0.49-24.323 5.286-24.323 6.74 0 9.831 10.808 10.076 27.053 0.216 14.28-2.03 29.142-5.696 35.645z m-5.81 58.464l1.534-4.05 2.088 3.795c11.69 21.245 26.858 38.967 43.538 51.315l3.595 2.662-4.38 0.904c-16.328 3.372-31.544 8.457-52.34 16.842 2.174-0.876-21.623 8.863-27.638 11.169l-5.252 2.013 2.802-4.877c12.35-21.496 23.758-47.326 36.052-79.773z m157.626 76.261c-7.864 3.104-24.777 0.329-54.569-12.387l-7.561-3.227 8.199-0.607c23.295-1.724 39.807-0.44 49.422 3.08 4.09 1.498 6.824 3.388 8.037 5.553 1.31 2.336 0.71 4.81-1.362 6.31-0.448 0.427-1.155 0.88-2.166 1.278z"
								fill="#6f74d1"
								p-id="5449"></path>
						</svg>
						<svg
							v-if="item.type == 'mp4'"
							class="icon"
							height="100"
							p-id="10582"
							t="1671761618887"
							version="1.1"
							viewBox="0 0 1024 1024"
							width="100"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M821 242.9H205.5c-14.4-0.1-28.2 5.5-38.4 15.6s-15.9 23.9-15.9 38.2v434.9c0.2 29.9 24.4 54.1 54.3 54.3H821c14.4 0.1 28.2-5.5 38.4-15.6s15.9-23.9 15.9-38.2V296.8c-0.5-29.8-24.6-53.7-54.3-53.9zM196.5 469.2h98.3v90.5h-98.3v-90.5z m143.5-181h332.1v452.5H340V288.2z m377.3 181H830v90.5H717.3v-90.5zM830 324.4V424H717.3V288.2h76.9c19.9 0.2 35.8 16.3 35.8 36.2z m-597.8-36.2h62.5V424h-98.3v-99.6c0.1-19.9 16-36 35.8-36.2z m-35.7 416.3v-99.6h98.3v135.8h-62.5c-19.9-0.2-35.8-16.4-35.8-36.2z m597.8 36.2h-76.9V604.9H830v99.6c0 19.8-15.9 36-35.7 36.2z"
								fill="#81b337"
								p-id="10583"></path>
							<path
								d="M593.9 494.5l-120.8-60.6c-11.3-5.4-19.9 0-19.9 12.2v136.7c0 12.2 9.1 17.6 20.4 12.2l102.7-51.1 17.7-9.1c21.6-10.9 22.1-29-0.1-40.3z"
								fill="#81b337"
								p-id="10584"></path>
						</svg>
						<div class="guidance-bottom">
							<span class="guidance-name">{{ item.name || '' }}</span>
							<span class="guidance-remark">{{ item.remark || '' }}</span>
							<span class="guidance-info" style="margin-top: 12px">格式：{{ item.type || '' }}</span>
							<span class="guidance-info" style="margin-top: 4px">最后修改时间：{{ item.updateTime || '' }}</span>
						</div>
					</div>
				</el-card>
			</div>
		</div>

		<el-dialog :title="nowData.name" :top="'5vh'" :visible.sync="lookFlag" width="50%">
			<div class="look-content">
				<div v-if="nowData.type != 'mp4'">
					<el-alert :closable="false" type="warning">请滑动鼠标至底部，阅读并确认全部内容</el-alert>
					<pdf v-for="i in numPages" :key="i" :page="i" :src="nowData.file"></pdf>
				</div>
				<video
					v-if="nowData.type == 'mp4'"
					id="video"
					:src="nowData.file"
					autoplay
					controls
					style="width: 100%; height: 100%"></video>
			</div>
			<div slot="footer" style="display: flex; justify-content: center">
				<el-button size="small" type="primary" @click="lookFlag = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {completedMaintenance, queryCompletionList} from '@/api/newGuidance/newGuidance'
import pdf from 'vue-pdf'

export default {
	name: 'guidanceIndex',
	mixins: [],
	components: {pdf},
	props: {},
	data() {
		return {
			nowData: {},
			completedFlag: false,
			numPages: 1, //pdf页数
			lookFlag: false,
			guidanceData: [],
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		completed(id) {
			if (this.completedFlag) {
				return
			}
			this.completedFlag = true
			completedMaintenance({maintenanceId: id}).then(({data}) => {
				if (data.code == 0) {
					this.queryList()
				}
			})
		},
		//查询列表数据
		queryList() {
			queryCompletionList({}).then(({data}) => {
				if (data.code == 0) {
					this.guidanceData = data.data.map((item) => ({
						...item,
						type: item.file.substring(item.file.lastIndexOf('.') + 1).toLowerCase(),
					}))
				}
			})
		},

		goComplte(item, index) {
			this.completedFlag = false
			this.lookFlag = true
			this.nowData = {...item}
			this.$nextTick(() => {
				//如果是视频类型 的话则监听 视频播放完成
				if (item.type == 'mp4') {
					let elevideo = document.getElementById('video')
					elevideo.addEventListener(
						'ended',
						() => {
							if (!this.guidanceData[index].completed) {
								//如果未完成状态
								this.completed(this.nowData.id)
							}
						},
						false,
					)
				} else {
					//如果是PDF类型 1.整页加载pdf
					let loadingTask = pdf.createLoadingTask(this.nowData.file)
					// 网上查询 都没有加promise执行的整页渲染 emmmm... 不知道他们怎么运行的
					loadingTask.promise
						.then((pdf) => {
							// this.laoclUrl = loadingTask
							this.numPages = pdf.numPages
							let elePdf = document.getElementsByClassName('look-content')[0]
							elePdf.scrollTop = 0
							if (!this.nowData.completed) {
								//如果未完成状态
								//如果pdf只有一页 则直接算看完 pdf
								if (pdf.numPages == 1) {
									this.completed(this.nowData.id)
								} else {
									//否则 2,监听滚动事件 判断pdf是否看完
									elePdf.onscroll = (e) => {
										//如果拖拽到最后一页
										if (
											!this.guidanceData[index].completed &&
											e.srcElement.scrollHeight - e.srcElement.scrollTop <= 1200
										) {
											this.completed(this.nowData.id)
										}
									}
								}
							}
						})
						.catch((err) => {
							console.error('pdf加载失败')
						})
				}
			})
		},
	},
	created() {
		this.queryList()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-alert__description {
	font-size: 14px;
	font-weight: bold;
	margin: 0;
}

::v-deep .el-button--small {
	font-size: 14px;
	padding: 8px 30px;
}

.guidance-main {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.guidance-status {
	position: absolute;
	right: 0;
	top: 0;
}

.guidance-bottom {
	margin-top: 35px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	.guidance-name {
		color: #000;
		font-weight: bold;
		font-size: 18px;
	}

	.guidance-info {
		font-size: 12px;
		color: #909399;
	}

	.guidance-remark {
		margin-top: 12px;
		font-size: 13.5px;
		line-height: 20px;
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}
}

.look-content {
	height: calc(100vh - 280px);
	overflow: auto;
}

::v-deep .el-dialog__body {
	padding: 0 20px;
}
</style>
